import { createContext, useContext, useState } from "react";

const AIContext = createContext(null);

export function AIProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null);

  const openAI = (prompt) => {
    if (typeof prompt === "string" && prompt.trim()) setPending(prompt.trim());
    setOpen(true);
  };

  return (
    <AIContext.Provider value={{ open, setOpen, openAI, pending, clearPending: () => setPending(null) }}>
      {children}
    </AIContext.Provider>
  );
}

export const useAI = () => useContext(AIContext);
